module.exports = __webpack_public_path__ + "img/programme1.5d72cc21.png";